<template>
  <div id="iframe-container" ref="whole_page" v-show="isCardActiveLocal">
    <!-- <iframe id="ispringQuizFrame" :src="ispringQuizUrl" style="height: 94vh;width: 99vw;" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe> -->
  </div>
</template>
<script>
  import { uuid } from 'vue-uuid';

  export default {
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      quizProp: {
        type: Object,
        required: true
      },
      popupXBtnClickedISpring: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        uuid: "",
        ispringquiz: {},
        logData: {},
        index: 0,
        isQuizFinished: false,
        ispringQuizUrl: null
      }
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          self.isQuizFinished = false;
          self.showQuiz();
          self.clearIFrameStorage();
          self.index++;
        }
      },
      popupXBtnClickedISpring: function(val) {
        var self = this;
        if(val && !self.isQuizFinished) {
          var ifrm = document.getElementById("ispringQuizFrame");
          ifrm.remove();
          var payload = {
            logIdentifier: self.uuid,
            toTaskId: null,
            taskId: self.quizProp.id,
            passingScore: self.logData.passingScore,
            passingPercent: self.logData.passingPercent,
            awardedScore: self.logData.awardedScore,
            quizDuration: self.logData.quizDuration,
            awardedPercent: self.logData.awardedPercent,
            quizTitle: self.logData.quizTitle,
            quizStatus: self.logData.quizStatus,
            completed: self.logData.completed
          };

          self.$emit("postEndLogISpring", payload);
        }
        else if(val && self.isQuizFinished) {
          self.$emit("refreshTasks");
        }
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      }
    },
    methods: {
      showQuiz() {
        var self = this;
        self.isQuizFinished = false;
        if (self.quizProp) {
          //Check if on mobile
          if (self.isMobile() && self.quizProp.isDecisive) {
            self.$vs.dialog({
              type: "confirm",
              color: "warning",
              title: "Mobile Device Detected",
              text: "Unfortunately this quiz cannot be completed on a mobile device (smartphone or tablet).\n\nPlease log in again from a computer (laptop or desktop-computer).",
              accept: self.closePopup,
              acceptText: "Close",
              cancel: self.closePopup
            });
            return;
          }

          self.uuid = self.$uuid.v4();
          self.logData.taskId = self.quizProp.id;
          self.logData.logIdentifier = self.uuid;
          self.logData.fromTaskId = null;
          self.logData.toTaskId = null;

          var currentUserId = JSON.parse(localStorage.getItem('Current_User_Id'));

          self.ispringQuizUrl = self.quizProp.url + "?userid=" + currentUserId + "&siteid=" + self.$getSiteId() + "&uniqueId=" + self.uuid;

          var ifrm = document.createElement("iframe");

          ifrm.id = "ispringQuizFrame";
          ifrm.setAttribute("src", self.ispringQuizUrl);
          ifrm.setAttribute("frameborder", "0");
          ifrm.setAttribute("allowfullscreen", "true");
          ifrm.setAttribute("mozallowfullscreen", "true");
          ifrm.setAttribute("webkitallowfullscreen", "true");
          ifrm.style.width = "99vw";
          ifrm.style.height = "94vh";

          document.getElementById("iframe-container").appendChild(ifrm);

          var onSuccess = function (response) {};

          var payload = {
            logIdentifier: self.logData.logIdentifier,
            toTaskId: self.logData.fromTaskId,
            fromTaskId: self.logData.toTaskId,
            taskId: self.quizProp.id,
          };

          self.$ajaxPost(self, "ISpringQuizTask/StartLogEntry", payload, onSuccess);

          self.ispringquiz = self.quizProp;
        }
      },
      quizFinished(quizResults) {
        var self = this;
        if (quizResults) {
          self.logData.fromTaskId = null;
          self.logData.toTaskId = null;

          var onSuccess = function (response) {};

          var payload = {
            logIdentifier: self.logData.logIdentifier,
            toTaskId: self.logData.fromTaskId,
            fromTaskId: self.logData.toTaskId,
            taskId: self.quizProp.id
          };

          self.$ajaxPost(self, "ISpringQuizTask/EndLogEntry", payload, onSuccess);

          self.isQuizFinished = true;
        }
      },
      closePopup() {
        var ifrm = document.getElementById("ispringQuizFrame");
        ifrm.remove();
        this.$emit("closePopup")
      },
      clearIFrameStorage() {
        document.getElementById('ispringQuizFrame').contentWindow.postMessage({
          event_id: 'ispringdone'
        }, "*");
      },
    },
    mounted() {
      var self = this;

      window.addEventListener("message", function () {
        if (event.data.event_id == 'ispring') {
          self.ispringquiz.quizResults = {};
          self.ispringquiz.quizResults.passingScore = isNaN(event.data.results.passingScore) ? null : event.data.results.passingScore;
          self.ispringquiz.quizResults.passingPercent = isNaN(event.data.results.passingPercent) ? null : event.data.results.passingPercent;
          self.ispringquiz.quizResults.awardedScore = isNaN(event.data.results.awardedScore) ? null : event.data.results.awardedScore;
          self.ispringquiz.quizResults.awardedPercent = isNaN(event.data.results.awardedPercent) ? null : event.data.results.awardedPercent;
          self.ispringquiz.quizResults.quizDuration = event.data.results.quizDuration;
          self.ispringquiz.quizResults.quizTitle = event.data.results.quizTitle;
          self.ispringquiz.quizResults.quizStatus = event.data.results.quizStatus;
          self.ispringquiz.quizResults.completed = true;

          self.logData.passingScore = isNaN(event.data.results.passingScore) ? null : event.data.results.passingScore;
          self.logData.passingPercent = isNaN(event.data.results.passingPercent) ? null : event.data.results.passingPercent;
          self.logData.awardedScore = isNaN(event.data.results.awardedScore) ? null : event.data.results.awardedScore;
          self.logData.quizDuration = event.data.results.quizDuration;
          self.logData.awardedPercent = isNaN(event.data.results.awardedPercent) ? null : event.data.results.awardedPercent;
          self.logData.quizTitle = event.data.results.quizTitle;
          self.logData.quizStatus = self.ispringquiz.quizResults.quizStatus;
          self.logData.completed = self.ispringquiz.quizResults.completed;
        }
      }, false);
    }
  }
</script>
<style lang="scss">
  #quizViewPopup div.vs-popup {
    width: 100%;
    height: 100%;

    .vs-popup--content {
      max-height: calc(100vh - 100px);
    }
  }

</style>